(() => {
  if (window.solsticeCardStatus) return;
  const selector = '.product-card-wrapper';
  const dataCache = new WeakMap();
  const dialog = document.getElementById('CardRestockDialog');
  if (!dialog) return;
  const form = dialog.querySelector('product-restock');
  const variantSelect = dialog.querySelector('select');
  let currentVariants = [];
  let trigger;
  let previousOverflow = '';

  function data(card) {
    const source = card.querySelector('[data-card-stock]');
    if (!source) return null;
    if (!dataCache.has(source)) {
      try { dataCache.set(source, { title: source.dataset.productTitle, variants: JSON.parse(source.dataset.variants) }); }
      catch { return null; }
    }
    return dataCache.get(source);
  }
  function matchingVariants(card, variants) {
    const family = card.querySelector('.card-only-colors input:checked')?.dataset.colorFamily || card.dataset.cardColor;
    const matching = variants.filter(variant => variant.family === family);
    return matching.length ? matching : variants;
  }
  function update(card) {
    const product = data(card);
    if (!product) return;
    const variants = matchingVariants(card, product.variants);
    const sold = variants.length > 0 && variants.every(variant => !variant.available);
    card.querySelector('[data-card-soldout]').hidden = !sold;
    card.querySelector('[data-card-restock]').hidden = !sold;
    const preorder=card.querySelector('[data-card-preorder]');
    if(preorder)preorder.hidden=sold || variants.some(variant=>variant.available && !variant.preorder);
  }
  function scan(root) {
    if (root.matches?.(selector)) update(root);
    root.querySelectorAll?.(selector).forEach(update);
  }
  function selectVariant() {
    const variant = currentVariants.find(variant => String(variant.id) === variantSelect.value);
    form.updateVariant(variant, !!variant && !variant.available);
  }
  async function open(button) {
    const card = button.closest(selector);
    const product = data(card);
    if (!product) return;
    await customElements.whenDefined('product-restock');
    currentVariants = product.variants.filter(variant => !variant.available);
    if (!currentVariants.length) return;
    trigger = button;
    dialog.querySelector('[data-card-restock-title]').textContent = product.title;
    variantSelect.replaceChildren(...currentVariants.map(variant => new Option(variant.title === 'Default Title' ? 'Modèle unique' : variant.title, String(variant.id))));
    const preferred = matchingVariants(card, currentVariants)[0];
    variantSelect.value = String(preferred.id);
    form.form.reset();
    form.form.elements.phone.setCustomValidity('');
    selectVariant();
    const showOptions = currentVariants.length > 1 || currentVariants[0].title !== 'Default Title';
    variantSelect.hidden = !showOptions;
    dialog.querySelector('label[for="CardRestockVariant"]').hidden = !showOptions;
    if (!dialog.open) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    }
    form.form.elements.email.focus({ preventScroll: true });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-card-restock]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    open(button);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('.card-only-colors input')) update(event.target.closest(selector));
  });
  window.addEventListener('global-color-switch', () => queueMicrotask(() => scan(document)));
  variantSelect.addEventListener('change', selectVariant);
  dialog.querySelector('[data-close-restock]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    form.version++;
    document.body.style.overflow = previousOverflow;
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  window.solsticeCardStatus = { scan };
  scan(document);
  new MutationObserver(changes => changes.forEach(change => change.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body, { childList: true, subtree: true });
})();
